import { gql } from '@apollo/client';

export const ACTIVATE_FEATURES = gql`
  mutation activateFeatures($input: ActivateFeaturesInput!) {
    activateFeatures(input: $input) {
      user {
        id
        roles {
          id
          permissions
        }
      }
    }
  }
`;

export interface ActivateFeaturesQueryVariables {
  input: {
    stressCheck?: boolean | null;
    stressCheckRole?: string | null;
    regularHealthCheckup?: boolean | null;
  };
}
